module.exports = __webpack_public_path__ + "prod/1.42.2/img/api_interface_show.f1737667.png";